var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: center;\n\n  .a-field-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 6px;\n  }\n\n  .a-field {\n    max-width: 500px;\n    width: 100%;\n    @media (max-width: 768px) {\n      padding-left: 24px;\n      padding-right: 24px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: center;\n\n  .a-field-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 6px;\n  }\n\n  .a-field {\n    max-width: 500px;\n    width: 100%;\n    @media (max-width: 768px) {\n      padding-left: 24px;\n      padding-right: 24px;\n    }\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .a-field-container {\n    display: flex;\n    align-self: flex-start;\n  }\n\n  .a-field {\n    max-width: 400px;\n    width: 100%;\n    @media (max-width: 768px) {\n      padding-left: 24px;\n      padding-right: 24px;\n    }\n  }\n\n  @media (max-width: 939px) {\n    flex-direction: column;\n    justify-content: center;\n\n    .a-field-container {\n      justify-content: center;\n      width: 100%;\n    }\n  }\n\n  @media (min-width: 940px) {\n    .a-field-container {\n      width: 50%;\n      justify-content: flex-end;\n      padding-right: ", ";\n    }\n\n    .a-field-container:nth-child(2n) {\n      justify-content: flex-start;\n      padding-right: 0;\n      padding-left: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .a-field-container {\n    display: flex;\n    align-self: flex-start;\n  }\n\n  .a-field {\n    max-width: 400px;\n    width: 100%;\n    @media (max-width: 768px) {\n      padding-left: 24px;\n      padding-right: 24px;\n    }\n  }\n\n  @media (max-width: 939px) {\n    flex-direction: column;\n    justify-content: center;\n\n    .a-field-container {\n      justify-content: center;\n      width: 100%;\n    }\n  }\n\n  @media (min-width: 940px) {\n    .a-field-container {\n      width: 50%;\n      justify-content: flex-end;\n      padding-right: ", ";\n    }\n\n    .a-field-container:nth-child(2n) {\n      justify-content: flex-start;\n      padding-right: 0;\n      padding-left: ", ";\n    }\n  }\n"]),
    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .a-field-container {\n    display: flex;\n    padding-right: ", ";\n    align-self: flex-end;\n  }\n\n  .a-field {\n    min-width: 150px;\n    max-width: 150px;\n  }\n\n  @media (max-width: 939px) {\n    flex-direction: column;\n    justify-content: center;\n    display: block;\n\n    .a-field-container {\n      justify-content: center;\n      padding-right: 0;\n    }\n    .a-field {\n      width: 100%;\n      max-width: 450px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .a-field-container {\n    display: flex;\n    padding-right: ", ";\n    align-self: flex-end;\n  }\n\n  .a-field {\n    min-width: 150px;\n    max-width: 150px;\n  }\n\n  @media (max-width: 939px) {\n    flex-direction: column;\n    justify-content: center;\n    display: block;\n\n    .a-field-container {\n      justify-content: center;\n      padding-right: 0;\n    }\n    .a-field {\n      width: 100%;\n      max-width: 450px;\n    }\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-top: 4px;\n  margin-bottom: 0px;\n  div {\n    margin-bottom: 0px;\n  }\n  div:first-of-type {\n    margin-left: 0px;\n  }\n  .a-buttons {\n    margin: 0px;\n    justify-content: flex-start;\n    @media (max-width: 768px) {\n      margin-left: 0px;\n      margin-right: 0px;\n    }\n    @media (min-width: 450px) {\n      > div {\n        button {\n          margin-left: 0;\n          margin-right: 0;\n        }\n      }\n    }\n    @media (max-width: 449px) {\n      > div:nth-child(2n + 1) {\n        button {\n          margin-left: 0;\n        }\n      }\n      > div:nth-child(2n) {\n        button {\n          margin-right: 0;\n        }\n      }\n    }\n\n    @media (max-width: 449px) {\n      justify-content: flex-start;\n    }\n  }\n  @media (max-width: 449px) {\n    &.a-buttons-uneven {\n      .a-buttons div {\n        width: 100%;\n        button {\n          margin-left: 0px;\n          margin-right: 0px;\n          max-width: 100%;\n        }\n      }\n    }\n  }\n"], ["\n  margin-top: 4px;\n  margin-bottom: 0px;\n  div {\n    margin-bottom: 0px;\n  }\n  div:first-of-type {\n    margin-left: 0px;\n  }\n  .a-buttons {\n    margin: 0px;\n    justify-content: flex-start;\n    @media (max-width: 768px) {\n      margin-left: 0px;\n      margin-right: 0px;\n    }\n    @media (min-width: 450px) {\n      > div {\n        button {\n          margin-left: 0;\n          margin-right: 0;\n        }\n      }\n    }\n    @media (max-width: 449px) {\n      > div:nth-child(2n + 1) {\n        button {\n          margin-left: 0;\n        }\n      }\n      > div:nth-child(2n) {\n        button {\n          margin-right: 0;\n        }\n      }\n    }\n\n    @media (max-width: 449px) {\n      justify-content: flex-start;\n    }\n  }\n  @media (max-width: 449px) {\n    &.a-buttons-uneven {\n      .a-buttons div {\n        width: 100%;\n        button {\n          margin-left: 0px;\n          margin-right: 0px;\n          max-width: 100%;\n        }\n      }\n    }\n  }\n"]);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from "react";
import styled from "styled-components";
import Buttons from "../Buttons";
var CenteredForm = styled.div(_templateObject);
var TwoColumnForm = styled.div(_templateObject2, function (props) {
  return props.theme.spaces.bitLoose;
}, function (props) {
  return props.theme.spaces.bitLoose;
});
var FluidForm = styled.div(_templateObject3, function (props) {
  return props.theme.spaces.loose;
});

var selectForm = function selectForm(props) {
  if (props.sidebyside === true) {
    return TwoColumnForm;
  }

  if (props.fluid === true) {
    return FluidForm;
  }

  return CenteredForm;
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var F = selectForm(this.props);

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        rest = _objectWithoutProperties(_props, ["children", "className"]);

    return React.createElement(F, _extends({
      className: className
    }, rest), children);
  };

  return Form;
}(Component);

export var FieldContainer = function (_Component2) {
  _inherits(FieldContainer, _Component2);

  function FieldContainer() {
    _classCallCheck(this, FieldContainer);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  FieldContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        fieldClass = _props2.fieldClass,
        rest = _objectWithoutProperties(_props2, ["children", "fieldClass"]);

    var fieldClasses = fieldClass ? fieldClass + " a-field" : "a-field";
    return React.createElement("div", _extends({
      className: "a-field-container"
    }, rest), React.createElement("div", {
      className: fieldClasses
    }, children));
  };

  return FieldContainer;
}(Component);
var FormFieldButtonsContainer = styled.div(_templateObject4);
export var FormFieldButtons = function (_Component3) {
  _inherits(FormFieldButtons, _Component3);

  function FormFieldButtons() {
    _classCallCheck(this, FormFieldButtons);

    return _possibleConstructorReturn(this, _Component3.apply(this, arguments));
  }

  FormFieldButtons.prototype.render = function render() {
    var _props3 = this.props,
        children = _props3.children,
        n = _props3.n;
    var length = n || children.length;
    var unevenclass = length % 2 === 1 ? "a-buttons-uneven" : "";
    return React.createElement(FormFieldButtonsContainer, {
      className: unevenclass
    }, React.createElement(Buttons, null, this.props.children));
  };

  return FormFieldButtons;
}(Component);
export default Form;